import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'

import actions from 'actions/crm/autoSentiment'
import crmState from './initial.state'

export default combineReducers({
  settings: createFullCycleHandlers(actions.settings, crmState.autoSentiment.settings)
})
